package com.exura.components.layouts.nav

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.exura.components.icons.UntiledIcon
import com.exura.features.localization.commonLocalization
import com.exura.features.userprofile.domain.model.DoctorProfile
import com.exura.features.userprofile.domain.model.OrganizationProfile
import com.exura.features.userprofile.domain.model.ProviderProfile
import com.exura.ui.Assets
import com.exura.ui.Dimens
import com.exura.util.AriaCurrent
import com.exura.util.ariaCurrent
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.div

@Composable
internal fun NavigationScope.AccountDropdown(
    profile: ProviderProfile? = null,
    subLinks: @Composable () -> Unit
) {
    var isOpen by remember { mutableStateOf(false) }

    Column(
        Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(Dimens.navNavigationEntriesGap),
    ) {

        NavigationButton(
            text = profile?.email ?: commonLocalization.current.nav.account,
            onClick = { isOpen = !isOpen },
            modifier = Modifier
                .ariaCurrent(if (isOpen) AriaCurrent.True else null),
            suffix = {
                if (isOpen) {
                    UntiledIcon(Assets.IconsUntiled.NAV_BUTTON_EXPANDED)
                }
            },
        ) { UntiledIcon(Assets.IconsUntiled.NAV_ELEMENT_PROFILE) }

        if (isOpen) {
            ProfileDetailsSection(isCollapsed = isNavigationCollapsed, profile = profile)
            SubLinksSection(isCollapsed = isNavigationCollapsed) { subLinks() }
        }

    }
}

@Composable
private fun SubLinksSection(
    isCollapsed: Boolean,
    subLinks: @Composable () -> Unit,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(left = if (isCollapsed) Dimens.spacingNone else Dimens.navElementIndent / 2),
        verticalArrangement = Arrangement.spacedBy(Dimens.navNavigationEntriesGap),
    ) {
        subLinks()
    }
}

@Composable
private fun ProfileDetailsSection(
    isCollapsed: Boolean,
    profile: ProviderProfile? = null,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(left = Dimens.navElementIndent),
        verticalArrangement = Arrangement.spacedBy(Dimens.navNavigationEntriesGap / 2),
    ) {
        SpanText(
            text = when (profile) {
                is DoctorProfile -> profile.fullName
                is OrganizationProfile -> profile.name
                else -> null
            } ?: "",
            modifier = NavTextStyle
                .toModifier(
                    if (isCollapsed) NavTextCollapsedVisibleVariant else null
                )
                .fontWeight(FontWeight.Medium)
        )

        SpanText(
            text = when (profile) {
                is DoctorProfile -> profile.specialization
                is OrganizationProfile -> profile.field
                else -> null
            } ?: "",
            modifier = NavTextStyle
                .toModifier(if (isCollapsed) NavTextCollapsedVisibleVariant else null)
        )

    }
}
